import { Modal as AntModal } from "antd"
import * as React from "react"
import { classNames } from "../../../utils/classNames"
import { ModalHeader, ModalHeaderProps } from "./components/ModalHeader"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { ModalFooter, ModalFooterProps } from "./components/ModalFooter"

type Props<HeaderPropType = string> = {
    size?: "tiny" | "small" | "default" | "large" | "largeXL"
    onClose?: () => void
    allowBackdropClose?: boolean
    verticalCentered?: boolean
    contentCentered?: boolean
    isVisible: boolean
    contentClassName?: string
    header?: ModalHeaderProps<HeaderPropType>
    footer?: ModalFooterProps
    children: React.ReactNode
}
export const Modal = <HeaderPropType extends string>({
    size = "default",
    onClose,
    allowBackdropClose,
    verticalCentered,
    contentCentered,
    isVisible,
    contentClassName,
    header,
    footer,
    children,
}: Props<HeaderPropType>) => {
    if (!isVisible) {
        return null
    }
    return (
        <AntModal
            destroyOnClose={true}
            closable={false}
            footer={null}
            title={null}
            centered={verticalCentered}
            onCancel={() => {
                if (allowBackdropClose && onClose) {
                    onClose()
                }
            }}
            visible={isVisible}
            className={classNames(classes.modal, classes.size[size], verticalCentered && classes.centered)}>
            <button onClick={() => onClose?.()} type="button" className={classes.closeIconWrap}>
                <XMarkIcon className={classes.closeIcon} />
            </button>
            <div className={classNames(classes.wrap, contentCentered && classes.wrapContentCentered)}>
                {header ? (
                    <div className={classes.headerFooterWrap}>
                        <ModalHeader title={header.title} subtitle={header.subtitle} tabs={header.tabs} />
                    </div>
                ) : null}
                <div className={classNames(classes.contentWrap, contentClassName)}>{children}</div>
                {footer ? (
                    <div className={classes.headerFooterWrap}>
                        <ModalFooter renderButtons={footer.renderButtons} />
                    </div>
                ) : null}
            </div>
        </AntModal>
    )
}

const classes = {
    modal: "w-full text-black/90 [&_.ant-modal-content]:rounded-md [&_.ant-modal-content]:overflow-hidden top-[20px] md:top-[100px]",
    centered: "md:top-0",
    size: {
        tiny: "max-w-md",
        small: "max-w-lg",
        default: "max-w-2xl",
        large: "max-w-3xl",
        largeXL: "max-w-5xl",
    },
    wrap: "-m-6",
    wrapContentCentered: "text-center",
    headerFooterWrap: "",
    contentWrap: "px-4 md:px-10 pt-5 pb-8",
    closeIconWrap: "absolute right-1 top-1 block cursor-pointer bg-transparent p-3 z-[10]",
    closeIcon: "h-auto w-[22px] opacity-50 hover:opacity-100",
}
